var map = {
  "./": "47679",
  "./accordion": "20665",
  "./accordion.js": "20665",
  "./add": "33268",
  "./add.js": "33268",
  "./destroy": "84537",
  "./destroy.js": "84537",
  "./edit": "36871",
  "./edit.js": "36871",
  "./index": "47679",
  "./index.js": "47679",
  "./show": "12718",
  "./show.js": "12718"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 39781;
